/* Probably we want to fetch defaults from our server for different themes in the future */

/* 
  ##### 
    CAUTION 
    Colors have to be HSLA format to work properly atm
  ##### 
*/
export const defaultTheme = {
  scrollBehavior: 'smooth',
  colors: {
    primary: 'hsla(240, 26.88%, 18.24%, 1)',
    secondary: 'hsla(232.26, 17.32%, 35.1%, 1)',
    primaryDark: 'hsla(308.57, 6.48%, 57.65%, 1)',
    primaryLight: 'hsla(240, 28.17%, 27.84%, 1)',
    primary50: 'hsla(240, 26.88%, 18.24%, 0.50)',
    secondaryDark: 'hsla(234.29, 17.07%, 24.12%, 1)',
    secondaryLight: 'hsla(234.19, 16.94%, 35.88%, 1)',
    secondary50: 'hsla(232.26, 17.32%, 35.1%, 0.50)',
    greyDefault: 'hsla(0, 0%, 85.1%, 1)',
    greyLight: 'hsla(0, 0%, 96.08%, 1)',
    greyDark: 'hsla(0, 0%, 31.37%, 1)',
    white: 'hsla(0, 0%, 100%, 1)',
    success: 'hsla(120, 100%, 25.1%, 1)',
    warning: 'hsla(38.82, 100%, 50%, 1)',
    error: 'hsla(0, 100%, 50%, 1)',
    headings: 'hsla(234.29, 17.07%, 24.12%, 1)',
    text: 'hsla(0, 0%, 31.37%, 1)',
  },
  /* CInspiration */
  CInspiration: {
    text: 'hsla(0, 0%, 31.37%, 1)',
    title: 'hsla(0, 0%, 31.37%, 1)',
    gridColor: 'var(--color-primary)',
  },
  /* Cookie Notice */
  cookie: {
    background: 'hsla(0, 0%, 100%, 1)',
    text: 'var(--color-text)',
    button: 'var(--color-primary)',
  },
  /* Fonts */
  fonts: {
    primary: {
      type: 'system',
      googleFont: 'Roboto',
    },
    secondary: {
      type: 'system',
      googleFont: 'Roboto',
    },
  },
  themeBorderThickness: '1px',
  themeShape: 'rounded',
  /* Button general */
  buttonTypography: {
    fontFamily: 'primary',
    fontSize: {
      desktop: {
        value: 16,
        unit: 'px',
      },
    },
    fontWeight: {
      desktop: '600',
    },
    fontTransform: 'None',
    fontSpacing: {
      desktop: {
        value: 0,
        unit: 'em',
      },
    },
  },
  /* Form general */
  formLabel: {
    fontFamily: 'primary',
    fontSize: {
      desktop: {
        value: 16,
        unit: 'px',
      },
    },
    fontWeight: {
      desktop: '600',
    },
    fontTransform: 'None',
    fontSpacing: {
      desktop: {
        value: 0,
        unit: 'em',
      },
    },
  },
  formPlaceholder: {
    fontFamily: 'primary',
    fontSize: {
      desktop: {
        value: 1,
        unit: 'em',
      },
    },
    lineHeight: {
      desktop: {
        value: 1.2,
        unit: 'em',
      },
    },
    fontWeight: {
      desktop: '600',
    },
    fontTransform: 'None',
    fontSpacing: {
      desktop: {
        // "value": 1.2,
        // "unit": "em"
      },
    },
  },
  /* Propasal not jet used */
  button: {
    shape: 'rounded',
  },
  baseField: {
    fieldLabel: 'var(--color-headings)',
    fieldBackground: 'var(--color-white)',
    fieldPlaceholder: 'var(--color-greyDark)',
    fieldText: 'var(--color-text)',
    fieldBorder: 'var(--color-greyDefault)',
    fieldFocusBorder: 'var(--color-primary)',
  },
  variants: {
    text: {
      largeHeading: {
        fontSize: {
          desktop: {
            value: 38,
            unit: 'px',
          },
        },
        lineHeight: {
          desktop: {
            value: 1.4,
            unit: 'em',
          },
        },
        fontWeight: {
          desktop: '500',
        },
        fontSpacing: {
          desktop: {
            value: 0,
            unit: 'em',
          },
        },
        fontTransform: 'none',
        fontFamily: 'primary',
        color: 'var(--color-headings)',
        linkColor: 'var(--color-primary)',
        linkHoverColor: 'var(--color-primaryDark)',
      },
      mediumHeading: {
        fontSize: {
          desktop: {
            value: 32,
            unit: 'px',
          },
        },
        lineHeight: {
          desktop: {
            value: 1.4,
            unit: 'em',
          },
        },
        fontFamily: 'primary',
        fontWeight: {
          desktop: '400',
        },
        fontTransform: 'none',
        fontSpacing: {
          desktop: {
            value: 0,
            unit: 'em',
          },
        },
        color: 'var(--color-headings)',
        linkColor: 'var(--color-primary)',
        linkHoverColor: 'var(--color-primaryDark)',
      },
      smallHeading: {
        fontFamily: 'primary',
        fontSize: {
          desktop: {
            value: 20,
            unit: 'px',
          },
        },
        lineHeight: {
          desktop: {
            value: 1.4,
            unit: 'em',
          },
        },
        fontTransform: 'none',
        fontSpacing: {
          desktop: {
            value: 0,
            unit: 'em',
          },
        },
        fontWeight: {
          desktop: '500',
        },
        color: 'var(--color-headings)',
        linkColor: 'var(--color-primary)',
        linkHoverColor: 'var(--color-primaryDark)',
      },
      bodyText: {
        fontFamily: 'primary',
        fontWeight: {
          desktop: '400',
        },
        fontTransform: 'none',
        fontSize: {
          desktop: {
            value: 16,
            unit: 'px',
          },
        },
        lineHeight: {
          desktop: {
            value: 1.4,
            unit: 'em',
          },
        },
        fontSpacing: {
          desktop: {
            value: 0,
            unit: 'em',
          },
        },
        color: 'var(--color-text)',
        linkColor: 'var(--color-primary)',
        linkHoverColor: 'var(--color-primaryDark)',
      },
      captionText: {
        fontFamily: 'primary',
        fontSize: {
          desktop: {
            value: 14,
            unit: 'px',
          },
        },
        lineHeight: {
          desktop: {
            value: 1.2,
            unit: 'em',
          },
        },
        fontWeight: {
          desktop: '500',
        },
        fontTransform: 'uppercase',
        fontSpacing: {
          desktop: {
            value: 0,
            unit: 'em',
          },
        },
        color: 'var(--color-text)',
        linkColor: 'var(--color-primary)',
        linkHoverColor: 'var(--color-primaryDark)',
      },
    },
    baseButton: {
      solid: {
        background: 'var(--color-primary)',
        color: 'var(--color-white)',
      },
      outlined: {
        border: 'var(--color-primary)',
        color: 'var(--color-primary)',
      },
      underlined: {
        border: 'green',
        color: 'white',
      },
      underlined: {
        color: 'var(--color-primary)',
      },
    },
    // "baseFields": {
    // "solid": {
    //   "fieldLabel": "var(--color-greyDefault)",
    //   "fieldBackground": "var(--color-white)",
    //   "fieldBorder": "var(--color-greyDefault)",
    //   "fieldPlaceholder":"var(--color-greyDark)",
    //   "fieldText": "var(--color-greyDark)",
    //   "fieldFocusBorder": "var(--color-primary)"
    // },
    // "outlined": {
    //   'fieldLabel': "var(--color-greyDefault)",
    //   'fieldBackground': "",
    //   'fieldBorder': "var(--color-greyDefault)",
    //   'fieldPlaceholder':"var(--color-greyDark)",
    //   'fieldText': "var(--color-greyDark)",
    //   'fieldFocusBorder': "var(--color-primary)"
    // },
    // "underlined": {
    //   'fieldLabel': "var(--color-greyDefault)",
    //   'fieldBackground': "",
    //   'fieldBorder': "var(--color-greyDefault)",
    //   'fieldPlaceholder':"var(--color-greyDark)",
    //   'fieldText': "var(--color-greyDark)",
    //   'fieldFocusBorder': "var(--color-primary)"
    // }
    // },
  },

  header: {
    general: {
      hamburgerColor: 'hsla(240, 0%, 0%, 1)',
      background: 'var(--color-white)',
      buttonSecondary: {
        variant: 'outlined',
        size: 's',
      },
      buttonPrimary: {
        variant: 'solid',
        size: 's',
      },
      logoWidth: {
        desktop: {
          unit: 'px',
          value: 120,
        },
      },
      height: {
        desktop: {
          unit: 'px',
          value: '100',
        },
      },
      navigationTypography: {},
      textLogoTypography: {},
    },
    transparent: {
      textLogoColor: 'var(--color-greyDefault)',
      background: 'hsla(240, 0%, 100%, 0)',
      hamburgerColor: 'hsla(240, 0%, 0%, 1)',
      buttonSecondary: {
        color: 'var(--color-greyDefault)',
        border: 'var(--color-greyDefault)',
      },
      buttonPrimary: {
        color: 'var(--color-greyDefault)',
        border: 'var(--color-greyDefault)',
      },
      navigationTypography: {
        linkColor: 'var(--color-greyDefault)',
      },
      textLogoTypography: {
        color: 'var(--color-greyDefault)',
      },
    },
    sidePanel: {
      background: 'var(--color-white)',
      backdrop: 'var(--color-primary50)',
      typography: '',
      closeIcon: 'var(--color-primaryDark)',
    },
    topbar: {
      background: 'var(--color-primaryDark)',
      typography: {
        color: 'var(--color-white)',
      },
      height: {
        desktop: {
          unit: 'px',
          value: '40',
        },
      },
    },
  },
};
